import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  countyChartVariables: {sdohKey: null, stateCode: null, stateCountyCode: null}
}

const countyChartSlice = createSlice({
  name: 'countyChart',
  initialState,
  reducers: {
    setCountyChartVariables: (state, action) => {
      state.countyChartVariables = action.payload
    },
    resetCountyChartVariables: (state) => {
      state.countyChartVariables = initialState.countyChartVariables
    }
  }
})

export const {setCountyChartVariables, resetCountyChartVariables} = countyChartSlice.actions

export const selectCountyChartVariables = (state) => state.countyChart.countyChartVariables

export default countyChartSlice.reducer
